export default function QuantityInput({ value, onChange }){
  return (<div className="inline-flex items-center rounded-xl border border-slate-200 overflow-hidden">
    <button onClick={()=>onChange(Math.max(1, value-1))} className="px-3 py-1">-</button>
    <span className="px-3">{value}</span>
    <button onClick={()=>onChange(value+1)} className="px-3 py-1">+</button>
  </div>);
}
